import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { init } from '@sitecore/engage';
import config from './temp/config';

const EngageContext = createContext();

const EngageProvider = ({ children }) => {
  const [engage, setEngage] = useState({});

  const loadEngage = useCallback(async () => {
    const engageEvent = await init({
      clientKey: config?.engageParams?.clientKey,
      targetURL: config?.engageParams?.targetURL,
      pointOfSale: config?.engageParams?.pointOfSale,
      cookieDomain: config?.engageParams?.cookieDomain,
      cookieExpiryDays: config?.engageParams?.cookieExpiryDays,
      forceServerCookieMode: false,
      includeUTMParameters: true,
      webPersonalization: true,
    });

    setEngage(engageEvent);
  }, []);

  useEffect(() => {
    loadEngage();
  }, [loadEngage]);

  return <EngageContext.Provider value={engage}>{children}</EngageContext.Provider>;
};

const useEngage = () => {
  const engage = useContext(EngageContext);
  return engage;
};

export { EngageProvider, useEngage };
